import React from 'react';
import "./ability.css";

const Ability = ({ number, description }) => {
  return (
    <div className='ability fsc'>
      <div className="d-text number">{number}</div>
      <div className="d-text description">{description}</div>
    </div>
  )
}

export default Ability